// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: calc(100% - 20px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.model-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.model-selector mat-form-field {
  width: 300px;
}

mat-tab-group {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
mat-tab-group ::ng-deep .mat-mdc-tab-body-wrapper {
  flex: 1;
  min-height: 0;
}
mat-tab-group ::ng-deep .mat-mdc-tab-body-content {
  overflow: hidden;
}

.tab-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.predictions-tab {
  padding: 0.5rem;
  gap: 0.5rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}

.predictions-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.predictions-header mat-form-field {
  width: 160px;
  font-size: 12px;
}
.predictions-header .prediction-count {
  font-size: 11px;
  opacity: 0.6;
}

.timeline-container {
  width: 100%;
  height: 120px;
  min-height: 120px;
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
}
.timeline-container .timeline-chart {
  width: 100%;
  height: 100%;
  overflow: visible;
}
.timeline-container .timeline-chart .grid-line {
  stroke: rgba(128, 128, 128, 0.15);
  stroke-width: 1;
}
.timeline-container .timeline-chart .prediction-line {
  stroke: var(--preset-text, #ccc);
  stroke-width: 1.5;
  opacity: 0.6;
}
.timeline-container .timeline-chart .prediction-point {
  fill: var(--preset-text, #aaa);
  cursor: pointer;
}
.timeline-container .timeline-chart .prediction-point:hover {
  fill: #4fc3f7;
}
.timeline-container .timeline-chart .prediction-point.selected {
  fill: #4fc3f7;
  stroke: #fff;
  stroke-width: 0.5;
  vector-effect: non-scaling-stroke;
}

.no-predictions {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  gap: 0.25rem;
}
.no-predictions mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.no-predictions p {
  margin: 0;
}

.drivers-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgba(128, 128, 128, 0.2);
  padding-top: 0.5rem;
}

.drivers-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 0.25rem 0.5rem;
}
.drivers-header .driver-timestamp {
  font-weight: 500;
  font-size: 12px;
}
.drivers-header .driver-prediction {
  font-size: 12px;
  opacity: 0.8;
  font-family: monospace;
}

.drivers-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}

.driver-header-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  font-size: 10px;
  font-weight: 600;
  opacity: 0.6;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
}

.driver-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  font-size: 11px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.08);
}
.driver-row:hover {
  background-color: var(--preset-hover);
}

.driver-rank {
  width: 20px;
  text-align: right;
  opacity: 0.5;
  font-size: 10px;
}

.driver-name {
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: monospace;
  font-size: 10px;
}

.driver-bar-header {
  flex: 1;
}

.driver-bar-container {
  flex: 1;
  height: 14px;
  background: rgba(128, 128, 128, 0.1);
  border-radius: 2px;
  overflow: hidden;
}

.driver-bar {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}

.saliency-bar {
  background: linear-gradient(90deg, #4fc3f7, #0288d1);
}

.driver-value {
  width: 50px;
  text-align: right;
  font-family: monospace;
  font-size: 10px;
  opacity: 0.8;
}

.config-group-logs {
  height: 200px;
  border-top: 1px solid rgba(128, 128, 128, 0.15);
  display: flex;
}
.config-group-logs app-terminal {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.config-group-logs app-terminal ::ng-deep ng-terminal {
  flex: 1;
  min-height: 0;
}

.config-tab {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
  padding: 0.5rem;
}

.config-panels {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.config-group {
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 4px;
  overflow: hidden;
}

.config-group-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: rgba(128, 128, 128, 0.05);
  border-bottom: 1px solid rgba(128, 128, 128, 0.15);
}
.config-group-header .config-group-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.7;
}
.config-group-header .config-group-title {
  font-weight: 500;
  font-size: 12px;
}
.config-group-header .config-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0;
}
.config-group-header .config-actions button {
  width: 28px;
  height: 28px;
  padding: 0;
  line-height: 28px;
  box-shadow: none !important;
}
.config-group-header .config-actions button.active {
  color: #4fc3f7;
}
.config-group-header .config-actions button ::ng-deep .mat-mdc-button-persistent-ripple {
  border-radius: 50%;
}
.config-group-header .config-actions button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.service-status {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 8px;
  text-transform: uppercase;
  font-weight: 600;
}
.service-status.status-active, .service-status.status-running {
  background: rgba(76, 175, 80, 0.2);
  color: #66bb6a;
}
.service-status.status-inactive, .service-status.status-unknown, .service-status.status-dead {
  background: rgba(128, 128, 128, 0.2);
  color: inherit;
  opacity: 0.6;
}
.service-status.status-failed {
  background: rgba(244, 67, 54, 0.2);
  color: #ef5350;
}

.config-group-body {
  padding: 0.5rem 0.75rem;
}
.config-group-body .config-row {
  margin-bottom: 0.25rem;
}
.config-group-body .config-loading-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  font-size: 11px;
  opacity: 0.7;
}
.config-group-body .config-loading-row mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.config-group-body .create-stream-row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.config-group-body .create-stream-row .config-field-inline {
  flex: 1;
  font-size: 12px;
}
.config-group-body .config-field {
  width: 100%;
  font-size: 12px;
}
.config-group-body app-dynamic-form {
  display: block;
  margin-top: 0.25rem;
}
.config-group-body app-dynamic-form ::ng-deep .mat-mdc-form-field {
  width: 100%;
  font-size: 12px;
}

.config-hint {
  font-size: 11px;
  opacity: 0.6;
  padding: 0.5rem 0;
  font-style: italic;
}

.config-hint-inline {
  font-size: 11px;
  opacity: 0.6;
  margin-left: 0.5rem;
  font-style: italic;
}

.config-save {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
}
.config-save .config-save-spacer {
  flex: 1;
}
.config-save button {
  font-size: 12px;
}
.config-save button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.config-save button .spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.invoke-tab {
  padding: 0.75rem;
  gap: 0.75rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}

.browse-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 0.5rem;
}
.browse-loading .browse-loading-message {
  font-size: 12px;
  opacity: 0.7;
  margin: 0;
}

.browse-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.browse-header .header-model-select {
  font-size: 12px;
}
.browse-header .header-model-select.loading {
  opacity: 0.7;
}
.browse-header .header-model-select .loading-spinner {
  font-size: 18px;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
}

.browse-metrics {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 4px;
  background: rgba(128, 128, 128, 0.04);
}
.browse-metrics .metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
}
.browse-metrics .metric .metric-value {
  font-size: 14px;
  font-weight: 600;
  font-family: monospace;
}
.browse-metrics .metric .metric-label {
  font-size: 9px;
  text-transform: uppercase;
  opacity: 0.5;
  letter-spacing: 0.5px;
}

.browse-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}
.browse-controls .browse-controls-left,
.browse-controls .browse-controls-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.browse-controls .browse-control {
  width: 170px;
  font-size: 12px;
}
.browse-controls .browse-control.disabled-control {
  opacity: 0.5;
}
.browse-controls .browse-action-btn {
  font-size: 12px;
  height: 48px;
  padding: 0 12px;
}
.browse-controls .browse-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 4px;
}
.browse-controls .browse-action-btn mat-icon.spinning {
  animation: spin 1s linear infinite;
}
.browse-controls .export-path {
  flex: 1;
  min-width: 0;
  font-size: 11px;
  font-family: monospace;
  color: #4fc3f7;
  cursor: pointer;
  text-decoration: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.browse-controls .export-path:hover {
  color: #81d4fa;
}

.browse-table-wrapper {
  flex: 1;
  min-height: 0;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
  position: relative;
}
.browse-table-wrapper.loading {
  opacity: 0.4;
  pointer-events: none;
}
.browse-table-wrapper .browse-table-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  opacity: 1;
}
.browse-table-wrapper table {
  width: 100%;
  font-size: 11px;
  --mat-table-row-item-container-height: 28px;
}
.browse-table-wrapper th, .browse-table-wrapper td {
  padding: 2px 8px;
  font-family: monospace;
  font-size: 11px;
}
.browse-table-wrapper .browse-row {
  cursor: pointer;
}
.browse-table-wrapper .browse-row:hover {
  background-color: var(--preset-hover);
}
.browse-table-wrapper .correct-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.browse-table-wrapper .correct-icon.correct {
  color: #66bb6a;
}
.browse-table-wrapper .correct-icon.incorrect {
  color: #ef5350;
}
.browse-table-wrapper .cell-spinner {
  font-size: 14px;
  width: 14px;
  height: 14px;
  opacity: 0.5;
}
.browse-table-wrapper .cell-spinner.spinning {
  animation: spin 1s linear infinite;
}
.browse-table-wrapper .browse-table-footer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0;
}
.browse-table-wrapper .browse-table-footer .browse-new-btn {
  font-size: 11px;
  line-height: 26px;
  padding: 0 8px;
  min-width: 0;
}
.browse-table-wrapper .browse-table-footer .browse-new-btn mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  margin-right: 2px;
}
.browse-table-wrapper .browse-table-footer .browse-new-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.browse-table-wrapper .browse-table-footer ::ng-deep .mat-mdc-paginator {
  font-size: 11px;
  --mat-paginator-container-size: 32px;
  margin-left: auto;
}

.browse-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  gap: 0.5rem;
  padding: 2rem 1rem;
  text-align: center;
}
.browse-empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.browse-empty p {
  margin: 0;
  font-size: 12px;
}
.browse-empty .empty-new-btn {
  margin-top: 0.5rem;
  opacity: 1;
  font-size: 12px;
}
.browse-empty .empty-new-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.invoke-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 4px;
  background: rgba(244, 67, 54, 0.05);
  font-size: 12px;
  color: #ef5350;
}
.invoke-error mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  gap: 0.5rem;
}
.placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.placeholder p {
  margin: 0;
}

.text-subtle {
  opacity: 0.6;
  font-size: 0.85em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/playground-widget/playground-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAAF;AAEE;EACE,OAAA;EACA,aAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;;AAKA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAFF;;AAMA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,qDAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAHF;AAKE;EACE,YAAA;EACA,eAAA;AAHJ;AAME;EACE,eAAA;EACA,YAAA;AAJJ;;AAQA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AALF;AAOE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AALJ;AAOI;EACE,iCAAA;EACA,eAAA;AALN;AAQI;EACE,gCAAA;EACA,iBAAA;EACA,YAAA;AANN;AASI;EACE,8BAAA;EACA,eAAA;AAPN;AASM;EACE,aAAA;AAPR;AAUM;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,iCAAA;AARR;;AAcA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AAXF;AAaE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAXJ;AAcE;EACE,SAAA;AAZJ;;AAiBA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8CAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AAdF;AAgBE;EACE,gBAAA;EACA,eAAA;AAdJ;AAiBE;EACE,eAAA;EACA,YAAA;EACA,sBAAA;AAfJ;;AAmBA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,qDAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,iDAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kDAAA;AAhBF;AAkBE;EACE,qCAAA;AAhBJ;;AAoBA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,OAAA;AAjBF;;AAoBA;EACE,OAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,oDAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAjBF;;AAqBA;EACE,aAAA;EACA,+CAAA;EACA,aAAA;AAlBF;AAoBE;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAlBJ;AAoBI;EACE,OAAA;EACA,aAAA;AAlBN;;AAwBA;EACE,gBAAA;EACA,qBAAA;EACA,qDAAA;EACA,eAAA;AArBF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArBF;;AAwBA;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,kDAAA;AArBF;AAuBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AArBJ;AAwBE;EACE,gBAAA;EACA,eAAA;AAtBJ;AAyBE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;AAvBJ;AAyBI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,2BAAA;AAvBN;AAyBM;EACE,cAAA;AAvBR;AA0BM;EACE,kBAAA;AAxBR;AA2BM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzBR;;AA+BA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA5BF;AA8BE;EACE,kCAAA;EACA,cAAA;AA5BJ;AA+BE;EACE,oCAAA;EACA,cAAA;EACA,YAAA;AA7BJ;AAgCE;EACE,kCAAA;EACA,cAAA;AA9BJ;;AAkCA;EACE,uBAAA;AA/BF;AAiCE;EACE,sBAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AAhCJ;AAkCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhCN;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAlCJ;AAoCI;EACE,OAAA;EACA,eAAA;AAlCN;AAsCE;EACE,WAAA;EACA,eAAA;AApCJ;AAuCE;EACE,cAAA;EACA,mBAAA;AArCJ;AAuCI;EACE,WAAA;EACA,eAAA;AArCN;;AA0CA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAvCF;;AA0CA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAvCF;;AA0CA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AAvCF;AAyCE;EACE,OAAA;AAvCJ;AA0CE;EACE,eAAA;AAxCJ;AA0CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAxCN;AA2CI;EACE,kCAAA;AAzCN;;AA8CA;EACE;IAAO,uBAAA;EA1CP;EA2CA;IAAK,yBAAA;EAxCL;AACF;AA2CA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,qDAAA;AAzCF;;AA4CA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AAzCF;AA2CE;EACE,eAAA;EACA,YAAA;EACA,SAAA;AAzCJ;;AA8CA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA3CF;AA6CE;EACE,eAAA;AA3CJ;AA6CI;EACE,YAAA;AA3CN;AA8CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AA5CN;;AAiDA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,2CAAA;EACA,kBAAA;EACA,qCAAA;AA9CF;AAgDE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AA9CJ;AAgDI;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AA9CN;AAiDI;EACE,cAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;AA/CN;;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AAjDF;AAmDE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;AAjDJ;AAoDE;EACE,YAAA;EACA,eAAA;AAlDJ;AAoDI;EACE,YAAA;AAlDN;AAsDE;EACE,eAAA;EACA,YAAA;EACA,eAAA;AApDJ;AAsDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AApDN;AAsDM;EACE,kCAAA;AApDR;AAyDE;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvDJ;AAyDI;EACE,cAAA;AAvDN;;AA4DA;EACE,OAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,qDAAA;EACA,kBAAA;AAzDF;AA2DE;EACE,YAAA;EACA,oBAAA;AAzDJ;AA4DE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,UAAA;AA1DJ;AA6DE;EACE,WAAA;EACA,eAAA;EACA,2CAAA;AA3DJ;AA8DE;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;AA5DJ;AA+DE;EACE,eAAA;AA7DJ;AA+DI;EACE,qCAAA;AA7DN;AAiEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/DJ;AAiEI;EACE,cAAA;AA/DN;AAkEI;EACE,cAAA;AAhEN;AAoEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAlEJ;AAoEI;EACE,kCAAA;AAlEN;AAsEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AApEJ;AAsEI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AApEN;AAsEM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AApER;AAuEM;EACE,YAAA;EACA,mBAAA;AArER;AAyEI;EACE,eAAA;EACA,oCAAA;EACA,iBAAA;AAvEN;;AA4EA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAzEF;AA2EE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzEJ;AA4EE;EACE,SAAA;EACA,eAAA;AA1EJ;AA6EE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;AA3EJ;AA6EI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA3EN;;AAgFA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,cAAA;AA7EF;AA+EE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7EJ;;AAkFA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AA/EF;AAiFE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/EJ;AAkFE;EACE,SAAA;AAhFJ;;AAoFA;EACE,YAAA;EACA,iBAAA;AAjFF","sourcesContent":[".content {\n  height: calc(100% - 20px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.model-selector {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n\n  mat-form-field {\n    width: 300px;\n  }\n}\n\nmat-tab-group {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n\n  ::ng-deep .mat-mdc-tab-body-wrapper {\n    flex: 1;\n    min-height: 0;\n  }\n\n  ::ng-deep .mat-mdc-tab-body-content {\n    overflow: hidden;\n  }\n}\n\n.tab-content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Predictions Tab\n.predictions-tab {\n  padding: 0.5rem;\n  gap: 0.5rem;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n}\n\n.predictions-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n\n  mat-form-field {\n    width: 160px;\n    font-size: 12px;\n  }\n\n  .prediction-count {\n    font-size: 11px;\n    opacity: 0.6;\n  }\n}\n\n.timeline-container {\n  width: 100%;\n  height: 120px;\n  min-height: 120px;\n  border: 1px solid rgba(128, 128, 128, 0.2);\n  border-radius: 4px;\n  padding: 8px;\n  box-sizing: border-box;\n\n  .timeline-chart {\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n\n    .grid-line {\n      stroke: rgba(128, 128, 128, 0.15);\n      stroke-width: 1;\n    }\n\n    .prediction-line {\n      stroke: var(--preset-text, #ccc);\n      stroke-width: 1.5;\n      opacity: 0.6;\n    }\n\n    .prediction-point {\n      fill: var(--preset-text, #aaa);\n      cursor: pointer;\n\n      &:hover {\n        fill: #4fc3f7;\n      }\n\n      &.selected {\n        fill: #4fc3f7;\n        stroke: #fff;\n        stroke-width: 0.5;\n        vector-effect: non-scaling-stroke;\n      }\n    }\n  }\n}\n\n.no-predictions {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n  gap: 0.25rem;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n// Drivers Panel\n.drivers-panel {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid rgba(128, 128, 128, 0.2);\n  padding-top: 0.5rem;\n}\n\n.drivers-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0 0.25rem 0.5rem;\n\n  .driver-timestamp {\n    font-weight: 500;\n    font-size: 12px;\n  }\n\n  .driver-prediction {\n    font-size: 12px;\n    opacity: 0.8;\n    font-family: monospace;\n  }\n}\n\n.drivers-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n}\n\n.driver-header-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.25rem;\n  font-size: 10px;\n  font-weight: 600;\n  opacity: 0.6;\n  text-transform: uppercase;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.2);\n}\n\n.driver-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.25rem;\n  font-size: 11px;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.08);\n\n  &:hover {\n    background-color: var(--preset-hover);\n  }\n}\n\n.driver-rank {\n  width: 20px;\n  text-align: right;\n  opacity: 0.5;\n  font-size: 10px;\n}\n\n.driver-name {\n  width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: monospace;\n  font-size: 10px;\n}\n\n.driver-bar-header {\n  flex: 1;\n}\n\n.driver-bar-container {\n  flex: 1;\n  height: 14px;\n  background: rgba(128, 128, 128, 0.1);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.driver-bar {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n.saliency-bar {\n  background: linear-gradient(90deg, #4fc3f7, #0288d1);\n}\n\n.driver-value {\n  width: 50px;\n  text-align: right;\n  font-family: monospace;\n  font-size: 10px;\n  opacity: 0.8;\n}\n\n// Inline log panels\n.config-group-logs {\n  height: 200px;\n  border-top: 1px solid rgba(128, 128, 128, 0.15);\n  display: flex;\n\n  app-terminal {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n\n    ::ng-deep ng-terminal {\n      flex: 1;\n      min-height: 0;\n    }\n  }\n}\n\n// Config Tab\n.config-tab {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n  padding: 0.5rem;\n}\n\n.config-panels {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.config-group {\n  border: 1px solid rgba(128, 128, 128, 0.2);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.config-group-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background: rgba(128, 128, 128, 0.05);\n  border-bottom: 1px solid rgba(128, 128, 128, 0.15);\n\n  .config-group-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    opacity: 0.7;\n  }\n\n  .config-group-title {\n    font-weight: 500;\n    font-size: 12px;\n  }\n\n  .config-actions {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    gap: 0;\n\n    button {\n      width: 28px;\n      height: 28px;\n      padding: 0;\n      line-height: 28px;\n      box-shadow: none !important;\n\n      &.active {\n        color: #4fc3f7;\n      }\n\n      ::ng-deep .mat-mdc-button-persistent-ripple {\n        border-radius: 50%;\n      }\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n}\n\n.service-status {\n  font-size: 10px;\n  padding: 1px 6px;\n  border-radius: 8px;\n  text-transform: uppercase;\n  font-weight: 600;\n\n  &.status-active, &.status-running {\n    background: rgba(76, 175, 80, 0.2);\n    color: #66bb6a;\n  }\n\n  &.status-inactive, &.status-unknown, &.status-dead {\n    background: rgba(128, 128, 128, 0.2);\n    color: inherit;\n    opacity: 0.6;\n  }\n\n  &.status-failed {\n    background: rgba(244, 67, 54, 0.2);\n    color: #ef5350;\n  }\n}\n\n.config-group-body {\n  padding: 0.5rem 0.75rem;\n\n  .config-row {\n    margin-bottom: 0.25rem;\n  }\n\n  .config-loading-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 0;\n    font-size: 11px;\n    opacity: 0.7;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .create-stream-row {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n\n    .config-field-inline {\n      flex: 1;\n      font-size: 12px;\n    }\n  }\n\n  .config-field {\n    width: 100%;\n    font-size: 12px;\n  }\n\n  app-dynamic-form {\n    display: block;\n    margin-top: 0.25rem;\n\n    ::ng-deep .mat-mdc-form-field {\n      width: 100%;\n      font-size: 12px;\n    }\n  }\n}\n\n.config-hint {\n  font-size: 11px;\n  opacity: 0.6;\n  padding: 0.5rem 0;\n  font-style: italic;\n}\n\n.config-hint-inline {\n  font-size: 11px;\n  opacity: 0.6;\n  margin-left: 0.5rem;\n  font-style: italic;\n}\n\n.config-save {\n  padding: 0.5rem 0;\n  display: flex;\n  align-items: center;\n\n  .config-save-spacer {\n    flex: 1;\n  }\n\n  button {\n    font-size: 12px;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      margin-right: 4px;\n    }\n\n    .spinning {\n      animation: spin 1s linear infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n// Playground Tab\n.invoke-tab {\n  padding: 0.75rem;\n  gap: 0.75rem;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n}\n\n.browse-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  gap: 0.5rem;\n\n  .browse-loading-message {\n    font-size: 12px;\n    opacity: 0.7;\n    margin: 0;\n  }\n}\n\n// Browse view\n.browse-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n\n  .header-model-select {\n    font-size: 12px;\n\n    &.loading {\n      opacity: 0.7;\n    }\n\n    .loading-spinner {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      animation: spin 1s linear infinite;\n    }\n  }\n}\n\n.browse-metrics {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid rgba(128, 128, 128, 0.15);\n  border-radius: 4px;\n  background: rgba(128, 128, 128, 0.04);\n\n  .metric {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1px;\n\n    .metric-value {\n      font-size: 14px;\n      font-weight: 600;\n      font-family: monospace;\n    }\n\n    .metric-label {\n      font-size: 9px;\n      text-transform: uppercase;\n      opacity: 0.5;\n      letter-spacing: 0.5px;\n    }\n  }\n}\n\n.browse-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.25rem;\n\n  .browse-controls-left,\n  .browse-controls-right {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .browse-control {\n    width: 170px;\n    font-size: 12px;\n\n    &.disabled-control {\n      opacity: 0.5;\n    }\n  }\n\n  .browse-action-btn {\n    font-size: 12px;\n    height: 48px;\n    padding: 0 12px;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      margin-right: 4px;\n\n      &.spinning {\n        animation: spin 1s linear infinite;\n      }\n    }\n  }\n\n  .export-path {\n    flex: 1;\n    min-width: 0;\n    font-size: 11px;\n    font-family: monospace;\n    color: #4fc3f7;\n    cursor: pointer;\n    text-decoration: underline;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &:hover {\n      color: #81d4fa;\n    }\n  }\n}\n\n.browse-table-wrapper {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n  position: relative;\n\n  &.loading {\n    opacity: 0.4;\n    pointer-events: none;\n  }\n\n  .browse-table-spinner {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 10;\n    opacity: 1;\n  }\n\n  table {\n    width: 100%;\n    font-size: 11px;\n    --mat-table-row-item-container-height: 28px;\n  }\n\n  th, td {\n    padding: 2px 8px;\n    font-family: monospace;\n    font-size: 11px;\n  }\n\n  .browse-row {\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--preset-hover);\n    }\n  }\n\n  .correct-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n\n    &.correct {\n      color: #66bb6a;\n    }\n\n    &.incorrect {\n      color: #ef5350;\n    }\n  }\n\n  .cell-spinner {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    opacity: 0.5;\n\n    &.spinning {\n      animation: spin 1s linear infinite;\n    }\n  }\n\n  .browse-table-footer {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.25rem 0;\n\n    .browse-new-btn {\n      font-size: 11px;\n      line-height: 26px;\n      padding: 0 8px;\n      min-width: 0;\n\n      mat-icon {\n        font-size: 14px;\n        width: 14px;\n        height: 14px;\n        margin-right: 2px;\n      }\n\n      &:disabled {\n        opacity: 0.4;\n        cursor: not-allowed;\n      }\n    }\n\n    ::ng-deep .mat-mdc-paginator {\n      font-size: 11px;\n      --mat-paginator-container-size: 32px;\n      margin-left: auto;\n    }\n  }\n}\n\n.browse-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n  gap: 0.5rem;\n  padding: 2rem 1rem;\n  text-align: center;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 12px;\n  }\n\n  .empty-new-btn {\n    margin-top: 0.5rem;\n    opacity: 1;\n    font-size: 12px;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      margin-right: 2px;\n    }\n  }\n}\n\n.invoke-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  border-radius: 4px;\n  background: rgba(244, 67, 54, 0.05);\n  font-size: 12px;\n  color: #ef5350;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n// Placeholder for pending tabs\n.placeholder {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n  gap: 0.5rem;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n.text-subtle {\n  opacity: 0.6;\n  font-size: 0.85em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
